// extracted by mini-css-extract-plugin
export var button = "products-slider-module--button--wbQfm";
export var imageContainer = "products-slider-module--image-container--NPcRO";
export var productCard = "products-slider-module--product-card--yxutk";
export var productsSlider = "products-slider-module--products-slider--Uj63y";
export var productsWrapper = "products-slider-module--products-wrapper--LqHF0";
export var sectionHeader = "products-slider-module--section-header--dxCrS";
export var title = "products-slider-module--title--8JYhJ";